"use client";

import { Button } from "../../../Button";

export interface NumericInputActionButtonsProps {
  minButtonValue?: number | string;
  maxButtonValue?: number | string;
  onChange?: (value: string) => void;
}

export const NumericInputActionButtons: React.FC<
  NumericInputActionButtonsProps
> = ({ minButtonValue, maxButtonValue, onChange }) => {
  const hasMinButton = minButtonValue !== undefined;
  const hasMaxButton = maxButtonValue !== undefined;

  if (!hasMinButton && !hasMaxButton) {
    return null;
  }

  return (
    <div className="ui:flex ui:items-center ui:gap-1.5">
      {hasMinButton && (
        <Button
          variant="peak"
          onClick={() => {
            onChange?.(String(minButtonValue));
          }}
        >
          MIN
        </Button>
      )}
      {hasMaxButton && (
        <Button
          variant="peak"
          onClick={() => {
            onChange?.(String(maxButtonValue));
          }}
        >
          MAX
        </Button>
      )}
    </div>
  );
};
